<template>
  <div class="discussion discussion-facebook">
    <div class="detail-event-header">
            <AvatarComponent :typeNetwork="page.network" :urlPicture="event.user && event.user.picture && event.user.picture.data && event.user.picture.data.url ? event.user.picture.data.url : null"></AvatarComponent>
            
            <div class="info">
                <div class="namePage">
                  {{getRecipientInfo().name}}
                </div>
                <div class="typeEvent">
                    <p>Discussion privée</p>
                </div>
            </div>
            <div class="selectActionEvent">
                <SelectComponent :changeValueSelect="changeStatus" :data="{treated:$t('dash.inbox.state.treated'),waiting:$t('dash.inbox.state.waiting')}" :valueSelect="[1, 3].includes(event.status) ? 'treated' : 'waiting'" :positionY="'bottom'" :positionAuto="false"></SelectComponent>
            </div>
    </div>
    <ul v-if="!isLoading && Object.keys(infoConversation).length && Object.keys(infoUser).length" class="discussion-order scrollable" ref="discussionScrool">
      <li v-for="(discut, key) in messages.data" :key="key">
          <div v-if="!messages.data[key+1] || new Date(discut.created_time).getTime() - new Date(messages.data[key+1].created_time).getTime() > 900000" class="date">{{ dateFormat(discut.created_time) }}</div>

          <div v-if="discut.from.id != page.network_id" class="message-received">
           
            <div class="message-received-content">
              <div class='message-received-content-text' :class="{'text':discut.message && (discut.message.length || (!discut.message.length && !discut.attachments))}">

               
                <p v-if="discut.message.length || (!discut.message.length && !discut.attachments)">{{ discut.message }}</p>
           
                <img v-if="discut.attachments"
                  class="message-received-content-image"
                  :src="discut.attachments.data[0].image_data.url"
                />
               
                <div class="containerReactions" :class="{'isHide' : true}">
                  <div class="reactions">
                    <i>😀</i>
                    <i class="fa-regular fa-face-smile"></i>
                  </div>
                </div>
              </div>
              <!-- <i class="fa-solid fa-ellipsis-vertical"></i> -->
            
            </div>

            <div class="container-actions-message"></div>
            
          </div> 

          <div v-else-if="discut.from.name == page.name" class="message-sent">
            <div class="message-sent-content">
              <ContextMenu :options="[{label: $t('dash.button.delete'), name : 'deleteComment'}]" :id="discut.id" v-on:clickOption="clickOptionMessage">
                <i class="fa-solid fa-ellipsis-vertical"></i>
              </ContextMenu>
              <div class='message-sent-content-text' :class="{'text':discut.message && discut.message.length}">
                
                <p v-if="discut.message && discut.message.length">{{ discut.message }}</p>
               
                <img class="message-received-content-image"
                  v-if="discut.attachments &&
                    typeof discut.attachments.data[0].image_data !=
                    'undefined'
                  "
                  :src="discut.attachments.data[0].image_data.url"
                />

                <div class="containerReactions" :class="{'isHide' : true}">
                  <div class="reactions">
                    <i>😀</i>
                    <i class="fa-regular fa-face-smile"></i>
                  </div>
                </div>
              
              </div>     
            </div>

        

              <div class="container-actions-message" >
                <div class="status" v-if="discut.tags.data[2].name == 'echec' || discut.tags.data[1].name == 'echec'">Echec de l'envoi</div>
                <div class="status" v-else-if="getIndexLastMessageSend == key">Envoyé</div>
              </div>
            
          </div>

         
      </li>

      <li class="loading-other-message">
        <div v-if="messages.paging.next" class="util-loader"></div>
        <p v-if="messages.paging.next">Chargement des anciens messages</p>
        <p v-else>Debut de la conversation</p>
      </li>
    </ul>
    <ul v-else class="discussion-order scrollable">
      <li v-for="index in 8" :key="index">
          
          <div v-if="Math.random() > 0.5" class="message-received content-loading">
           <div class="message-received-content">
            <div class='message-received-content-text text'>
               <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>
             </div>
           </div>
           <div class="container-actions-message"></div>
          </div> 
          <div v-else class="message-sent content-loading">
            <div class="message-sent-content">

             
              <div class='message-sent-content-text text'>    
                <p>{{ 'w'.repeat(5+Math.random()*100) }}</p>            
              </div>     
            </div>
            <div class="container-actions-message"></div>
            
          </div>
      </li>
    </ul>

    <!-- send message -->
    <FormSendMessage :acceptTypeMedia="'image/*'" v-on:onSubmitMessage="onSubmitMessage"></FormSendMessage>
    
  </div>

  <!-- savoir si c est un message recus ou envoyé  {{ discut.from.name }} {{ page.name }} sont egal. -->
</template>

<script>
import moment from 'moment'
import Moderation from './../../mixins/Moderation'



import 'emoji-mart-vue-fast/css/emoji-mart.css'
import ContextMenu from '../contextMenu/contextMenuInit.vue'
import FormSendMessage from './FormSendMessage'
import AvatarComponent from './../utils/avatar.vue'
import SelectComponent from './../utils/select.vue'

export default {
  name: 'component-discussion',

  mixins: [Moderation],

  components: {
    ContextMenu,
    FormSendMessage,
    AvatarComponent,
    SelectComponent
  },

  props: {

    messages : Object,
    infoConversation : Object,
    infoUser : Object,
    event: Object,
    page: Object,
    isLoading : {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      showEmojiPicker: false,
      message: null,
      user: null,
      url: [],
      fileInput: [], // Store our uploaded file
      fileInputParesed: []
    }
  },

  mounted() {
    if(this.$refs.discussionScrool)
      this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
  },

  beforeDestroy() {
    if(this.$refs.discussionScrool)
      this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
  },

  methods: {

    changeStatus(status){
      this.$emit('changeStatus', status)
    },

    onChange() {
      this.fileInput = [...this.$refs.file.files]
      console.log('this.$refs.file', this.$refs.file)
    },
    
    previewFiles(e) {
      console.log('nombre d images', e.target.files.length)
      console.log(e.target.files)
      for (var file of e.target.files) {
        this.url.push(URL.createObjectURL(file))
      }
      console.log(this.url)
    },

    async onSubmitMessage(formData,filesUrl = []) {
      if (formData.get('message')) {
        this.messages.data = [{
          "created_time":new Date().toISOString(),
          "from":  this.infoConversation.participants.data.find(participant => participant.id == this.page.network_id),
          "id":"",
          "message": formData.get('message'),
          "tags":{"data":[{"name":"inbox"},{"name":""},{"name":"source:web"}]},
          "to":{
            "data":[{"name": this.infoUser.first_name+" "+this.infoUser.last_name,"email":this.infoUser.id+"@facebook.com","id": this.infoUser.id}]
          }
        },...this.messages.data]
      } 

      if(formData.get('file[]') && filesUrl.length > 0) {
        filesUrl.forEach(url => {
          console.log("url",url)
          this.messages.data = [{
            "created_time":new Date().toISOString(),
            "from":  this.infoConversation.participants.data.find(participant => participant.id == this.page.network_id),
            "message": "",
            "attachments":{
              "data":[
                {
                  "image_data":{
                    "url":url,
                  }
                }
              ],
            },
            "id":"",
            "tags":{"data":[{"name":"inbox"},{"name":""},{"name":"source:web"}]},
            "to":{
              "data":[{"name": this.infoUser.first_name+" "+this.infoUser.last_name,"email":this.infoUser.id+"@facebook.com","id": this.infoUser.id}]
          }},...this.messages.data]
        });    
      }
      
      let recipientId = this.messages.data[0].from.id != this.page.network_id ? this.messages.data[0].from.id : this.messages.data[0].to.data[0].id
      
      let result = await this.sendMessage(this.page, recipientId, formData)

      if (result.body.success) {
        this.messages.data[0].tags.data[1].name = "sent"
        if (filesUrl.length > 0 && formData.get('message'))  this.messages.data[1].tags.data[1].name = "sent"
      }else{
        this.messages.data[0].tags.data[1].name = "echec"
        if (filesUrl.length > 0 && formData.get('message'))  this.messages.data[1].tags.data[1].name = "echec"
      }
    },

    clickOptionMessage(id, nameOption) {
      switch (nameOption) {
        case 'deleteMessage':

        break
      }
    },

    dateFormat(dateMessage) {
      if (typeof dateMessage !== "object") {
        dateMessage = new Date(dateMessage)
      }
      let date = new Date()
      let tab_Month= ["Jan", "Févr", "Mars", "Avr", "Mai", "Juin", "Juill", "Août", "Sept", "Oct", "Nov", "Déc"];

      if((date.getDate().toString() + date.getMonth().toString() + date.getFullYear().toString()) == (dateMessage.getDate().toString() + dateMessage.getMonth().toString() + dateMessage.getFullYear().toString())){
          return "Aujourd'hui à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
          
      }else if((date.getFullYear() == dateMessage.getFullYear()) && (date.getMonth() == dateMessage.getMonth()) && dateMessage.getDate() == (date.getDate() - 1)){
          return "Hier à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes() ;
      }else{
          return "Le "+dateMessage.getDate()+" "+tab_Month[dateMessage.getMonth()]+" "+dateMessage.getFullYear()+" à "+dateMessage.getHours()+":"+(dateMessage.getMinutes()<10?'0':'') + dateMessage.getMinutes()  ;
      }
    },

    handleScroll(e) {
      if (e.target.scrollHeight - (e.target.offsetHeight - e.target.scrollTop) < 20 && this.$refs.discussionScrool) {
        this.$refs.discussionScrool.removeEventListener('scroll', this.handleScroll);
        this.getOtherMessage()
      }
    },

    getRecipientInfo() {
     return this.infoConversation.participants && this.infoConversation.participants.data ? this.infoConversation.participants.data.filter(participant => participant.id !== this.event.page)[0] : this.event.user.name
    },

    async getOtherMessage() {
      if (this.messages && this.messages.paging && this.messages.paging.next) {
        let request = await this.$http.get(this.messages.paging.next, {}).then(res => res, err => err);
        // console.log(request.body,equest.body.datarequest.body.paging)
        if (request.body && request.body.data) {
          if (request.body.paging) this.messages.paging = request.body.paging
          let newArray = (this.messages.data).concat(request.body.data)
          this.messages.data = newArray
        }

        if (request.body.paging && request.body.paging.next && this.$refs.discussionScrool) {
          this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
        }else{
          this.messages.paging = {}
        }
      }
    },
  },

  computed: {
      getIndexLastMessageSend() {
        return this.messages.data.findIndex((discut) => (discut.tags.data[2] && discut.tags.data[2].name == 'sent') || (discut.tags.data[1] && discut.tags.data[1].name == 'sent'))
      }
  },

  watch: {
    event() {
      if (this.$refs.discussionScrool) {
        this.$refs.discussionScrool.addEventListener('scroll', this.handleScroll);
      }
    }
  }
}
</script>